const qualifications = [
  '10th Pass',
  '12th Pass',
  'Diploma',
  'ITI',
  'B.A.',
  'B.Com',
  'B.Sc',
  'B.E. / B.Tech',
  'BCA',
  'BBA',
  'B.Ed',
  'B.Pharm',
  'MBBS',
  'BDS',
  'BAMS',
  'BHMS',
  'B.Arch',
  'LLB',
  'M.A.',
  'M.Com',
  'M.Sc',
  'M.E. / M.Tech',
  'MCA',
  'MBA',
  'M.Ed',
  'M.Pharm',
  'MD',
  'MS',
  'LLM',
  'Ph.D',
  'CA',
  'CS',
  'ICWA',
  'Other',
];

export default qualifications;
